import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { cloneElement } from 'react';
import cn from 'classnames';
import parseClassnames from "../../../helpers/parseClassnames";
import { jsx as _jsx } from "react/jsx-runtime";
var Body = function Body(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'm' : _ref$type,
    body = _ref.body,
    isDark = _ref.isDark,
    hasMoreElements = _ref.hasMoreElements;
  var classes = hasMoreElements ? cn('block text-center', type === 'm-form' ? 'mb-24' : 'mb-32', _defineProperty({}, type === 'm-form' ? 'sm:mb-32' : 'sm:mb-40', type !== 's')) : 'block text-center';
  if (typeof body === 'string') {
    return /*#__PURE__*/_jsx("p", {
      className: cn(classes, 'font-body2', isDark ? 'text-white' : 'text-base-main'),
      children: body
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var bodyElement = body;
  return /*#__PURE__*/cloneElement(bodyElement, {
    className: parseClassnames(bodyElement.props.className || '', classes)
  });
};
export default Body;